export enum MaintenanceMode {
    BANNER = 'banner',
    PAGE = 'page',
}

export type MaintenanceFlag = {
    mode: MaintenanceMode | null;
    title?: string;
    message?: string;
    eta?: string;
    contact?: string;
};
